import React, { Fragment } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import globalStyles from 'src/styles/globalStyles'
import PageTransition from 'src/components/PageTransition'
import ScrollListener from 'src/components/ScrollListener'
import { Global, css } from '@emotion/react'
import IntersectionObserverPolyfill from 'src/components/IntersectionObserverPolyfill'
import AppProvider from 'src/state/AppState'
import OverlayState from 'src/state/OverlayState'

import './reset.css'

const Layout = ({ children, location }) => {
  const { allContentfulSiteSettings } = useStaticQuery(
    graphql`
      query {
        allContentfulSiteSettings {
          edges {
            node {
              ...SiteSettings
            }
          }
        }
      }
    `
  )
  const site = allContentfulSiteSettings.edges[0].node
  return (
    <Fragment>
      <IntersectionObserverPolyfill>
        <OverlayState>
          <AppProvider>
            <ScrollListener>
              <Global
                styles={css`
                  ${ globalStyles }
                `}
              />
              <PageTransition location={location || { pathName: '/' }}>
                {children}
              </PageTransition>
            </ScrollListener>
          </AppProvider>
        </OverlayState>
      </IntersectionObserverPolyfill>
    </Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
